import { render, staticRenderFns } from "./Schema.vue?vue&type=template&id=6f50bfed"
import script from "./Schema.vue?vue&type=script&lang=js"
export * from "./Schema.vue?vue&type=script&lang=js"
import style0 from "./Schema.vue?vue&type=style&index=0&id=6f50bfed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports